import { db } from '@/lib/db/index';
import type { WorkOrder, Mold } from '@/types/maintenance';

// Write-through cache helpers — called after every successful Supabase fetch.
// These run silently; cache failures never surface to the user.

export async function cacheWorkOrders(orgId: string | null, workOrders: WorkOrder[]): Promise<void> {
  try {
    await db.work_orders.bulkPut(workOrders);
    if (orgId) {
      await db.cache_meta.put({ key: `wo_last_synced_${orgId}`, value: new Date().toISOString() });
    }
  } catch (e) {
    if (import.meta.env.DEV) console.warn('[cache] cacheWorkOrders failed', e);
  }
}

export async function cacheWorkOrder(wo: WorkOrder): Promise<void> {
  try {
    await db.work_orders.put(wo);
  } catch (e) {
    if (import.meta.env.DEV) console.warn('[cache] cacheWorkOrder failed', e);
  }
}

export async function cacheMolds(orgId: string | null, molds: Mold[]): Promise<void> {
  try {
    await db.molds.bulkPut(molds);
    if (orgId) {
      await db.cache_meta.put({ key: `molds_last_synced_${orgId}`, value: new Date().toISOString() });
    }
  } catch (e) {
    if (import.meta.env.DEV) console.warn('[cache] cacheMolds failed', e);
  }
}

export async function getLastSyncedAt(orgId: string, entity: 'wo' | 'molds'): Promise<string | null> {
  try {
    const meta = await db.cache_meta.get(`${entity}_last_synced_${orgId}`);
    return meta?.value ?? null;
  } catch {
    return null;
  }
}
